import { Star } from "lucide-react";

export const Stars = ({ count = 5, className = "", size = 16 }) => {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${count} de 5 estrelas`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          strokeWidth={1.5}
          className={i <= count ? "fill-[#E20074] text-[#E20074]" : "fill-none text-[#D4D4D4]"}
        />
      ))}
    </div>
  );
};
